<template>
  <z-page>
    <!-- 图表表头选择 -->
    <div class="page-search">
      <el-radio-group v-model="index" size="mini">
        <el-radio-button :label="0">新增客户分析</el-radio-button>
        <el-radio-button :label="1">客户转化分析</el-radio-button>
      </el-radio-group>
    </div>
    <!-- 图表 -->
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>产品名称：</div>
        <div class="long">
          <el-select
            size="mini"
            v-model="pieSearch.productId"
            @change="getalldata()"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option
              v-for="(item,index) in product"
              :key="index"
              :label="item.category_name"
              :value="item.ecsProduct.id"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div v-show="index == 0" class="search-item">
        <div>时间：</div>
        <div class="long">
          <el-date-picker
            size="mini"
            v-model="pieSearch.statisticsTime"
            type="month"
            value-format="timestamp"
            format="yyyy-MM "
            placeholder="选择月"
            :picker-options="pickerOptions"
            @change="getalldata()"
          ></el-date-picker>
        </div>
      </div>

      <div v-show="index == 1" class="search-item">
        <div>时间：</div>
        <div class="long">
          <el-date-picker
            size="mini"
            v-model="pieSearch.year"
            type="year"
            value-format="timestamp"
            format="yyyy"
            placeholder="选择年"
            :picker-options="pickerOptions"
            @change="getalldata()"
          ></el-date-picker>
        </div>
      </div>
    </div>

    <div class="tab-main">
      <pieGroup :data="chartData" :show="index == 0"></pieGroup>
      <column title="客户月度转化分析" :data="columudata" :show="index == 1"></column>
    </div>

    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>账号：</div>
        <div>
          <el-input
            size="mini"
            v-model="search.account"
            placeholder="请输入账号"
            suffix-icon="el-icon-search"
          ></el-input>
        </div>
      </div>

      <div class="search-item">
        <div>产品名称：</div>
        <div class="long">
          <el-select size="mini" v-model="search.productId" slot="prepend" placeholder="请选择">
            <el-option
              v-for="(item,index) in product"
              :key="index"
              :label="item.category_name"
              :value="item.ecsProduct.id"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <div>会员等级：</div>
        <div class="long">
          <el-select size="mini" v-model="search.memberLevel" slot="prepend" placeholder="请选择">
            <el-option
              v-for="(item,index) in memberLevelList"
              :key="index"
              :label="item.member_level|Level"
              :value="item.member_level"
            >{{item.member_level|Level}}</el-option>
          </el-select>
        </div>
      </div>
      <div class="search-item">
        <div>用户来源：</div>
        <div class="long">
          <el-select
            size="mini"
            v-model="search.registerSource"
            slot="prepend"
            placeholder="请选择"
          >
            <el-option  label="官网" value="1"></el-option>
            <el-option label="其他" value="2"></el-option>
            <el-option label="不限" :value="null"></el-option>
          </el-select>
        </div>
      </div>

      <div class="search-item">
        <div>所属行业：</div>
        <div class="long">
          <el-select size="mini" v-model="search.belongIndustry" slot="prepend" placeholder="请选择">
            <el-option
              v-for="(item,index) in belongIndustry"
              :key="index"
              :label="item.belong_industry||'其他'"
              :value="item.belong_industry"
            >{{item.belong_industry||'其他'}}</el-option>
          </el-select>
        </div>
      </div>

      <div @click="searchdata()" class="search-btn z-btn normal">搜索</div>
      <div @click="clearsearch()" style="margin-left:20px;" class="search-btn">清除搜索</div>
      <span class="z-link" style="margin-left:5px;" @click="pop_flag = true">高级搜索</span>
    </div>

    <!-- 列表 -->

    <div class="page-list">
      <div class="list-head">
        <div>账号</div>
        <div>公司名称 </div>
        <div>添加时间</div>
        <div>转化时间</div>
        <div>用户来源</div>
        <div>会员等级</div>
        <div class="tipdiv">
          用户规模
          <img class="Notes" src="~@/assets/img/help.svg">
          <div class="tip">用户规模标签——根据用户企业子账号数量而定： <br>&#12288;&#12288;微企业：10个以内；<br>&#12288;小型企业：10~20个； <br>&#12288;中型企业：20~50个；<br>&#12288;大型企业：50个以上。</div>
        </div>
        <div class="tipdiv">
          消费等级
           <img class="Notes" src="~@/assets/img/help.svg">
          <div class="tip">消费等级标签——根据用户每个月的订单总额而定： <br>&#12288;普通消费：本月消费金额1000元以下；<br>&#12288;中通消费：本月消费金额1000元以上，5000元以下； <br>&#12288;大宗消费：本月消费金额5000元以上；。</div>
        
          </div>
        <div>所属行业</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div v-for="(item, index) in data_list" :key="index" class="list-item">
          <div>{{ item.account }}</div>
          <div>{{ item.companyName ||'--'}}</div>
          <div>{{ item.authorizedTime }}</div>
          <div>{{item.openProductTime ||'--'}}</div>

          <div>{{item.registerSource=='1'?'官网':'其他'||'--'}}</div>
          <div>{{ item.memberLevel |Level}}</div>
          <div>{{ item.tagSize |TagSize}}</div>
          <div>{{ item.tagConsume |tagConsume}}</div>
          <div>{{ item.belongIndustry || '其他'}}</div>
        </div>
        <div style="text-align: center" v-if="data_list.length<=0" class="list-item">暂无数据</div>
      </div>
    </div>
    <z-pagination
      @sizeChange="getData()"
      @pageChange="handleCurrentChange"
      :current-page.sync="nowpage"
      :page-size="10"
      :total="total"
    ></z-pagination>
    <!-- 高级搜索 -->
    <z-windowPop
      v-model="pop_flag"
      :btnshow="true"
      @confirm="$func.shake(searchdata)"
      savetext="查找"
      @change="advancedClear()"
      title="高级搜索"
      height="360px"
      width="504px"
    >
      <!-- 客户详情 -->
      <div class="detail-search">
        <div class="item">
          <div class="item-item">
            <span>账号：</span>
            <el-input
              size="mini"
              v-model="search.account"
              placeholder="请输入账号"
              suffix-icon="el-icon-search"
            ></el-input>
          </div>

          <div class="item-item">
            <span>产品名称：</span>
            <el-select size="mini" v-model="search.productId" slot="prepend" placeholder="请选择">
              <el-option
                v-for="(item,index) in product"
                :key="index"
                :label="item.category_name"
                :value="item.ecsProduct.id"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="item">
          <span>添加时间：</span>
          <el-date-picker
            class="date-picker"
            v-model="search.authorizedTimeStart"
            size="mini"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>-
          <el-date-picker
            class="date-picker"
            v-model="search.authorizedTimeEnd"
            size="mini"
            type="date"
            placeholder="选择日期"
            value-format="timestamp"
          ></el-date-picker>
        </div>
        <div class="item">
          <span>转化时间：</span>
          <el-date-picker
            class="date-picker"
            v-model="search.openProductTimeStart"
            size="mini"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>-
          <el-date-picker
            class="date-picker"
            v-model="search.openProductTimeEnd"
            size="mini"
            type="date"
            placeholder="选择日期"
            value-format="timestamp"
          ></el-date-picker>
        </div>
        <div class="item">
          <div class="item-item">
            <span>用户规模：</span>
            <el-select size="mini" v-model="search.tagSize" slot="prepend" placeholder="请选择">
              <el-option
                v-for="(item,index) in tagSize"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div class="item-item">
            <span>消费等级：</span>
            <el-select size="mini" v-model="search.tagConsume" slot="prepend" placeholder="请选择">
              <el-option
                v-for="(item,index) in tagConsume"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="item">
          <div class="item-item">
            <span>所属行业：</span>
            <el-select size="mini" v-model="search.belongIndustry" slot="prepend" placeholder="请选择">
              <el-option
                v-for="(item,index) in belongIndustry"
                :key="index"
                :label="item.belong_industry||'其他'"
                :value="item.belong_industry"
              >{{item.belong_industry||'其他'}}</el-option>
            </el-select>
          </div>

          <div class="item-item">
            <span>会员等级：</span>
            <el-select size="mini" v-model="search.memberLevel" slot="prepend" placeholder="请选择">
              <el-option
                v-for="(item,index) in memberLevelList"
                :key="index"
                :label="item.member_level|Level"
                :value="item.member_level"
              >{{item.member_level|Level}}</el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="btns">
                    <div class="z-btn"  @click="searchDetailData()">查询</div>
                    <div class="z-btn default" @click="clearDetail()">清空</div>
        </div>-->
      </div>
    </z-windowPop>
  </z-page>
</template>
<script>


import pieGroup from "@/components/pie-group.vue";
import column from "@/components/column.vue";
export default {
  components: {
    pieGroup,
    column
  },

  data() {
    return {
      // 限制时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      // 饼图搜索条件
      pieSearch: {
        productId: "",
        statisticsTime: Date.parse(new Date()),
        year: Date.parse(new Date())
      },
      value2: new Date(),
      pop_flag: false, //高级搜索
      index: 0, // 视图index
      belongIndustry: [], //所属行业列表
      memberLevelList: [], // 会员等级列表
      loading: false,
      search: {
        // 搜索框列表
        openProductTimeStart: "", //转化时间开始
        openProductTimeEnd: "", //转化时间结束
        authorizedTimeStart: "", //开始时间
        authorizedTimeEnd: "", //结束时间
        account: "", //账号
        memberLevel: "", //会员等级
        belongIndustry: "", //  所属行业
        productId: "", // 产品ID
        tagSize: "", // 用户规模
        tagConsume: "", //消费等级
        registerSource:null
      },

      searching: {
        // 真实所用到的  搜索容器
        openProductTimeStart: "", //转化时间开始
        openProductTimeEnd: "", //转化时间结束
        authorizedTimeStart: "",
        authorizedTimeEnd: "",
        account: "",
        memberLevel: "",
        belongIndustry: "",
        productId: "",
        tagSize: "",
        tagConsume: "",
        registerSource:null
      },
      //用户规模
      tagSize: [
        {
          text: "微企业",
          value: "0"
        },
        {
          text: "小型企业",
          value: "1"
        },
        {
          text: "中型企业",
          value: "2"
        },
        {
          text: "大型企业",
          value: "3"
        }
      ],
      tagConsume: [
        {
          text: "普通消费",
          value: "0"
        },
        {
          text: "中等消费",
          value: "1"
        },
        {
          text: "大宗消费",
          value: "2"
        }
      ],
      product: [],
      data_list: [],
      nowpage: 1,
      total: 0,
      chartData: {
        // 来电统计
        level: [],
        size: [],
        industry: []
      },
      columudata: {
        addUserCount: [],
        conversionCount: []
      }
    };
  },
  watch: {
    value2: {
      handler(val, oldval) {},
      deep: true
    }
  },

  created() {
    // 获得产品并且赋值给弹框
    this.$store.dispatch("getproduct").then(res => {
      if (res[0]) {
        this.searching.productId = res[0].ecsProduct.id;
        this.search.productId = res[0].ecsProduct.id;
        this.pieSearch.productId = res[0].ecsProduct.id;
        this.product = res;
      }
      this.getcondition();
      this.getalldata();
    });
  },

  methods: {
    // 获取饼图数据和柱状图数据
    getalldata() {
      this.getPieData();
      this.getcolumndata();
    },
    //获得柱状图数据
    getcolumndata() {
      if (!this.pieSearch.year) {
        return;
      } else {
        this.columudata.addUserCount = [];
        this.columudata.conversionCount = [];
        let url = `/api/supplier/get/user/conversion/analysis`;

        this.$http
          .post(url, {
            productId: this.pieSearch.productId,
            authorizedTime: this.$func
              .myTimeToLocal(this.pieSearch.year)
              .substring(0, 4),
            openProductTime: this.$func
              .myTimeToLocal(this.pieSearch.year)
              .substring(0, 4)
          })
          .then(res => {
            res.res_data.userConversion.map((val, i) => {
              this.columudata.addUserCount.push(val[i].addUserCount);
              this.columudata.conversionCount.push(val[i].conversionCount);
            });
          });
      }
    },
    // 获取饼图数据
    getPieData() {
      if (!this.pieSearch.statisticsTime) {
        return;
      } else {
        let url = `/api/supplier/get/add/user/analysis`;

        this.$http
          .post(url, {
            productId: this.pieSearch.productId,
            authorizedTime: this.$func
              .myTimeToLocal(this.pieSearch.statisticsTime)
              .substring(0, 7)
          })
          .then(res => {
            this.chartData.level = [];
            this.chartData.size = [];
            this.chartData.industry = [];
            let name = [
              "未付费会员",
              "普通会员",
              "银卡会员",
              "金卡会员",
              "特惠会员",
              "内部会员"
            ];
            if (res.res_data.memberLevelList.length > 0) {
              res.res_data.memberLevelList.map(val => {
                this.chartData.level.push({
                  name: name[val.member_level],
                  value: val["count(member_level)"]
                });
              });
            } else {
              this.chartData.level = [
                {
                  name: "未付费会员",
                  value: 0
                },
                {
                  name: "普通会员",
                  value: 0
                },
                {
                  name: "银卡会员",
                  value: 0
                },
                {
                  name: "金卡会员",
                  value: 0
                }
              ];
            }
            if (res.res_data.tagSizeList.length > 0) {
              res.res_data.tagSizeList.map(val => {
                this.chartData.size.push({
                  name: this.tagSize[val.tag_size].text,
                  value: val["count(tag_size)"]
                });
              });
            } else {
              this.chartData.size = [
                {
                  name: "微企业",
                  value: 0
                },
                {
                  name: "小型企业",
                  value: 0
                },
                {
                  name: "中型企业",
                  value: 0
                },
                {
                  name: "大型企业",
                  value: 0
                }
              ];
            }

            if (res.res_data.belongIndustryList.length > 0) {
              res.res_data.belongIndustryList.map(val => {
                if (val["belong_industry"] == "") {
                  val["belong_industry"] = "其他";
                }
                this.chartData.industry.push({
                  name: val.belong_industry,
                  value: val["count(belong_industry)"]
                });
              });
            } else {
              this.chartData.industry = [
                {
                  name: "暂无数据",
                  value: 0
                }
              ];
            }
          });
      }
    },
    // 高级搜索
    advancedSearch() {},
    //高级搜索取消
    advancedClear() {
      this.search.tagConsume = "";
      this.search.tagSize = "";
      this.search.authorizedTimeStart = "";
      this.search.authorizedTimeEnd = "";
      this.search.openProductTimeStart = "";
      this.search.openProductTimeEnd = "";
    },
    //获取 会员等级和所属行业
    getcondition() {
      this.loading = true;
      let url = `/api/supplier/get/user/search/params/list`;
      this.$http
        .post(url, {})
        .then(res => {
          if (res.code == "200") {
            this.memberLevelList = res.res_data.memberLevelList;
            this.belongIndustry = res.res_data.belongIndustry;

            this.belongIndustry.map(val => {
              if (val.belong_industry == "") {
                val.belong_industry = "其他";
              }
            });

            this.getData();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //搜索方法
    searchdata() {
      this.searching = JSON.parse(JSON.stringify(this.search));
      this.pop_flag = false;
      this.getData(1);
    },
    // 获取数据接口
    getData(num) {
      let url = `/api/supplier/get/authorized/user/analysis`;
      if (this.searching.belongIndustry == "其他") {
        this.searching.belongIndustry = "";
      } else if (this.searching.belongIndustry == "") {
        this.searching.belongIndustry = null;
      }
      this.$http
        .post(url, {
          authorizedTimeStart:
            this.$func.myTimeToLocal(this.searching.authorizedTimeStart) ||
            null,
          openProductTimeStart:
            this.$func.myTimeToLocal(this.searching.openProductTimeStart) ||
            null,
          openProductTimeEnd:
            this.$func.myTimeToLocal(this.searching.openProductTimeEnd) || null,

          authorizedTimeEnd:
            this.$func.myTimeToLocal(this.searching.authorizedTimeEnd) || null,
          account: this.searching.account || null,
          memberLevel: this.searching.memberLevel || null,
          belongIndustry: this.searching.belongIndustry,
          page: num || this.nowpage,
          productId: this.searching.productId,
          tagSize: this.searching.tagSize || null,
          tagConsume: this.searching.tagConsume || null,
          register_source:this.searching.registerSource
        })
        .then(res => {
          if (res.code == "200") {
            this.data_list = res.res_data.list;
            this.total = res.res_data.total;
            this.advancedClear();
          }
        });
    },
    // 当前页改变方法
    handleCurrentChange(val) {
      this.nowpage = val;
      this.getData();
    },
    clearsearch() {
      this.search = {
        openProductTimeStart: "", //转化时间开始
        openProductTimeEnd: "", //转化时间结束
        authorizedTimeStart: "", //开始时间
        authorizedTimeEnd: "", //结束时间
        account: "", //账号
        memberLevel: "", //会员等级
        belongIndustry: "", //  所属行业
        productId: "", // 产品ID
        tagSize: "", // 用户规模
        tagConsume: "", //消费等级
        registerSource:null
      };
      this.searching = {};

      this.search.productId = this.product[0].ecsProduct.id;
      this.searching.productId = this.product[0].ecsProduct.id;
      this.getData(1);
    }
  }
};
</script>
<style lang="less" scoped>
.list-head,
.list-item {
  .tipdiv {
    overflow: visible;
    position: relative;

    .Notes {
      display: inline-block;
      width: 14px;
      box-sizing: border-box;
      vertical-align: middle;
      &:hover {
        cursor: pointer;
        & + .tip {
          opacity: 1;
        }
      }
    }
    .tip {
      pointer-events: none;
      position: absolute;
      background: rgba(0, 0, 0, 0.7);
      opacity: 0;
      z-index: 3;
      transition: 0.3s;
      top: 100%;
      left:0;
      color: #fff;
      white-space: nowrap;
      padding: 0 8px;
      line-height: 28px;
      border-radius: 4px;
    }
  }
  > div {
    &:nth-child(2){
      text-align: center;
      width: 10%;
    }
    &:nth-child(3){
      width: 13.5%;
    }
    &:nth-child(4){
      width: 13.5%;
    }
    width: 10%;
  }
}
.detail-search {
  padding: 10px 24px;
  .item {
    width: 100%;
    span {
      display: inline-block;
      width: 70px;
    }
    padding-bottom: 16px;
    &:last-child {
      padding-bottom: 0px;
    }
    .date-picker {
      width: calc(~"50% - 44px");
    }
    .item-item {
      padding-right: 5px;
      &:last-child {
        padding-left: 5px;
        padding-right: 0px;
      }
      span {
        text-align: right;
        display: inline-block;
        width: 70px;
      }
      div {
        width: calc(~"100% - 75px");
      }
      display: inline-block;
      width: 50%;
    }
  }
}
</style>
